import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["type", "disabled"]

import { computed } from 'vue'
    import { SavingState } from '@common/Common'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SaveButton',
  props: {
    savingState: {},
    isFormSubmit: { type: Boolean }
  },
  emits: ["saveChanges"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- derived ----------------

    const buttonText = computed(() =>
    {
        switch (props.savingState)
        {
            case SavingState.InProgress:
                return 'Saving...'
            case SavingState.Pending:
                return 'Save changes'
            case SavingState.Saved:
                return 'Saved'
            default:
                return 'Save'
        }
    })

    const buttonClass = computed(() =>
    {
        switch (props.savingState)
        {
            case SavingState.InProgress:
            case SavingState.Pending:
                return 'btn-warning'
            case SavingState.Saved:
            default:
                return 'btn-success'
        }
    })

    const isButtonDisabled = computed(() =>
        props.savingState === SavingState.InProgress ||
        props.savingState === SavingState.Saved
    )

    // ---------------- methods ----------------

    function saveChanges()
    {
        if (props.isFormSubmit)
            return

        emit('saveChanges')
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.isFormSubmit ? 'submit' : 'button',
    class: _normalizeClass(['btn', buttonClass.value]),
    disabled: isButtonDisabled.value,
    onClick: saveChanges,
    style: {"padding":"0.7em 2em"}
  }, _toDisplayString(buttonText.value), 11 /* TEXT, CLASS, PROPS */, _hoisted_1))
}
}

})